var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.03,8.5c0,.79-.12,1.46-.36,2.01-.24,.55-.54,1.02-.92,1.42s-.77,.74-1.19,1.03c-.42,.3-.81,.58-1.19,.85-.37,.27-.68,.57-.92,.89-.24,.32-.36,.69-.36,1.13v.59h-2.28v-.64c0-.63,.12-1.17,.34-1.62,.23-.45,.53-.85,.89-1.2,.36-.36,.75-.68,1.16-.99,.41-.3,.79-.62,1.15-.94,.36-.33,.65-.7,.89-1.1,.23-.41,.35-.89,.35-1.44s-.14-1.09-.41-1.58c-.28-.49-.68-.88-1.21-1.18-.53-.3-1.17-.45-1.93-.45-.7,0-1.33,.13-1.88,.4-.55,.27-.99,.65-1.31,1.13-.32,.49-.48,1.06-.48,1.72,0,.24,.03,.49,.08,.73,.05,.24,.13,.49,.24,.75l-2.22,.79c-.16-.38-.28-.76-.36-1.13-.08-.38-.12-.76-.12-1.13,0-1.11,.27-2.08,.81-2.91,.54-.83,1.26-1.47,2.18-1.93,.92-.46,1.94-.69,3.07-.69,1.25,0,2.31,.25,3.2,.74,.89,.49,1.57,1.15,2.05,1.99,.48,.83,.72,1.76,.72,2.78Zm-6,10c-.83,0-1.5,.67-1.5,1.5s.67,1.5,1.5,1.5,1.5-.67,1.5-1.5-.67-1.5-1.5-1.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconQuestion);
export default __webpack_public_path__ + "static/1773309961/media/icon-question.1d7689a57dc84a53d99913c6eaebaff7.svg";
export { ForwardRef as ReactComponent };